export default __webpack_public_path__ + "static/rifatHamoudi@2x-cd7b1b8d39b2b3a7b3ff4dbd2b2137e4.jpg";